import React, {Component} from 'react';

class FocusFour extends Component {
    componentDidMount() {
        require("./css/FocusFour.css");
    }
    render() {
        return(
            <div className="FocusFour_Area">
                <div className="FocusFour_Container">
                    <div className="FocusFour_Cards">
                        <div className="Focus_Wrapper">
                            <a className="Focus_Link" href={this.props.Link1? this.props.Link1: "/Members"} target={this.props.External1?"_blank":"_self"}  rel="noopener noreferrer">
                                <div className="Focus_Wrapper_Content">
                                    <h3 className="Focus_Title">{this.props.Title1? this.props.Title1:"Members"}</h3>
                                    <p className="Focus_Description">
                                    {this.props.Message1? this.props.Message1: "Whether it is checking the status of a claim, finding a dentist near you or determining your out of pocket costs, we've got you covered!"}
                                    
                                    </p>
                                </div>
                                <div className="Focus_Button">
                                    <p className="Focus_Button_Link">{this.props.Button1? this.props.Button1: "Learn More"}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="FocusFour_Cards">
                        <div className="Focus_Wrapper">
                            <a className="Focus_Link" href={this.props.Link2? this.props.Link2: "/Employers"} target={this.props.External2?"_blank":"_self"} >
                                <div className="Focus_Wrapper_Content">
                                    <h3 className="Focus_Title">{this.props.Title2? this.props.Title2:"Employers"}</h3>
                                    <p className="Focus_Description">
                                    {this.props.Message2? this.props.Message2: "At Matrix Healthcare, we pride ourselves on service. We are here to help with claim resolutions, plan designs, and data reporting."}
                                    
                                    </p>
                                </div>
                                <div className="Focus_Button">
                                    <p className="Focus_Button_Link">{this.props.Button2? this.props.Button2: "Learn More"}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="FocusFour_Cards">
                        <div className="Focus_Wrapper">
                            <a className="Focus_Link"  href={this.props.Link3? this.props.Link3: "/Providers"} target={this.props.External3?"_blank":"_self"} >
                                <div className="Focus_Wrapper_Content">
                                    <h3 className="Focus_Title">{this.props.Title3? this.props.Title3:"Providers"}</h3>
                                    <p className="Focus_Description">
                                    {this.props.Message3? this.props.Message3: "Need to view the status of a claim or print off an explanation of benefits?"}
                                    
                                    </p>
                                </div>
                                <div className="Focus_Button">
                                    <p className="Focus_Button_Link">{this.props.Button3? this.props.Button3: "Learn More"}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="FocusFour_Cards">
                        <div className="Focus_Wrapper">
                            <a className="Focus_Link"  href={this.props.Link4? this.props.Link4: "/Brokers"} target={this.props.External4?"_blank":"_self"} >
                                <div className="Focus_Wrapper_Content">
                                    <h3 className="Focus_Title">{this.props.Title4? this.props.Title4:"Brokers"}</h3>
                                    <p className="Focus_Description">
                                    {this.props.Message4? this.props.Message4: "With a large Utah network of 2,700 dentists and a national network of 200,000, we are capable of taking care of your clients needs."}
                                    </p>
                                </div>
                                <div className="Focus_Button">
                                    <p className="Focus_Button_Link">{this.props.Button4? this.props.Button4: "Learn More"}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};
export default FocusFour;